export default __webpack_public_path__ + "static/media/logo.b55946fa.png";